import FakeInput from "@edaz/edazkit/controls/FakeInput";
import Tooltip from "@edaz/edazkit/Tooltip";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { formatDate } from "utils/localizations";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import Section from "views/common/section";

const RejectionDetailSection: ViewComponent<RejectedCustomerRefundCandidateDetailViewModel> = observer(({ vm }) => {
  return (
    <Section title={vm.translate("rejectionDetail")} context={vm.item} className="mt-4">
      <Form.Row>
        <Form.Group as={Col} lg={6}>
          <Form.Label>{vm.translateAttribute("rejectionDate")}</Form.Label>
          <FakeInput target={vm.item} property="rejectionDate" valueFormatter={formatDate} />
        </Form.Group>
        <Form.Group as={Col} lg={6}>
          <Form.Label>{vm.translateAttribute("rejectedBy")}</Form.Label>
          <FakeInput target={vm.item} property="rejectedBy" />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>{vm.translateAttribute("rejectionReason")}</Form.Label>
          <Tooltip id="rejection-detail-section" trigger={["hover", "focus"]} tooltip={vm.item.rejectionReason}>
            <div>
              <FakeInput target={vm.item} property="rejectionReason" />
            </div>
          </Tooltip>
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default RejectionDetailSection;
